/*
 * Copyright (C) 2018-2019 Nettoken Ltd. All rights reserved.
 *
 * This document is the property of Nettoken Ltd.
 * It is considered confidential and proprietary.
 *
 * This document may not be reproduced or transmitted in any form,
 * in whole or in part, without the express written permission of
 * Nettoken Ltd.
 */

/**
 * If not available natively, uses a separate CSPRNG to polyfill the Web Crypto API.
 * Used in worker threads in some browsers.
 *
 * @source https://github.com/jedisct1/libsodium.js/issues/46
 *
 * @param {*} seed Securely generated 32-byte key.
 */
const polyfill = seed => {
  try {
    self.crypto.getRandomValues(new Uint8Array(1)); // eslint-disable-line no-restricted-globals
    return;
  }
  catch (e) {
    // Fall through to polyfill.
  }

  const sodium = () => self.sodium; // eslint-disable-line no-restricted-globals
  const nonce = new Uint32Array(2);
  let isActive = false;
  let sodiumReadyPromise;

  self.crypto = { // eslint-disable-line no-restricted-globals
    getRandomValues(arrayBufferView) {
      /* Handle circular dependency between this polyfill and libsodium */
      const sodiumExists = typeof sodium() !== 'undefined' && sodium().crypto_stream_chacha20;
      if (!isActive) {
        if (sodiumExists && !sodiumReadyPromise) {
          sodiumReadyPromise = sodium().ready.then(() => {
            isActive = true;
          });
        }
        return arrayBufferView;
      }
      if (!sodiumExists) {
        throw new Error('No CSPRNG found.');
      }
      ++nonce[nonce[0] === 4294967295 ? 1 : 0]; // eslint-disable-line no-plusplus
      const newBytes = sodium().crypto_stream_chacha20(arrayBufferView.byteLength, seed, new Uint8Array(nonce.buffer, nonce.byteOffset, nonce.byteLength)); // eslint-disable-line max-len
      new Uint8Array(arrayBufferView.buffer, arrayBufferView.byteOffset, arrayBufferView.byteLength).set(newBytes); // eslint-disable-line max-len
      sodium().memzero(newBytes);
      return arrayBufferView;
    },
    subtle: {},
  };
};

export default polyfill;
